<!-- ///////////////////////////////////////////////////// -->

<span id="modelopen" data-bs-toggle="modal" data-bs-target="#clientauthorizationedit"></span>
<div class="modal  fade" id="clientauthorizationedit" tabindex="-1" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">

    <div class="modal-dialog mw-100">
        <div class="modal-content  ">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">
                    New Authorization </h5>

            </div>
            <div class="alert alert-warning alert-dismissible fade show" *ngIf="saveAuthErr!=''" role="alert">
                <p>{{saveAuthErr}}</p>
                <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"
                    (click)="saveAuthErr=''">
                    <span aria-hidden="true"> </span>
                </button>
            </div>
            <div class="modal-body ">

                <div class="row" *ngFor="let its of serviceinbox;let i=index">

                    <div class="row mt-3 ">

                        <div class="col-lg-2 col-md-6 col-sm-12">
                            <label >Company
                            </label>
                            <ng-select [clearable]="true" [searchable]="true" [items]="companyList"
                            id="AuthCompany"
                                [(ngModel)]="its.companyId" bindLabel="label" bindValue="value">
                            </ng-select>
                        </div>
                        <div class="col-lg-4 ">
                            <div class="row ">
                                <div class="col-lg-6 mw-100 col-md-12 col-sm-12">
                                    <label>Start Date
                                        <sup class="super-script">&nbsp;*</sup>
                                    </label>
                                    <my-date-picker [options]="myDatePickerOptions" [selDate]="its.startDate"
                                    id="AuthStartDate"
                                        placeholder="mm/dd/yyyy" (inputFieldChanged)="CareAUTHStartDatechange(i,$event)"
                                        (dateChanged)="onDateChangedCareAUTHStart(i,$event)"
                                        (focusout)="calculatetotalhour(its.startDate,its.endDate,its.totalUnits,i,its.billingvalue)">
                                    </my-date-picker>
                                </div>
                                <div class="col-lg-6 mw-100 col-md-12 col-sm-12">
                                    <label>End Date
                                        <sup class="super-script">&nbsp;*</sup>
                                    </label>
                                    <my-date-picker [options]="myDatePickerOptions" [selDate]="its.endDate"
                                    id="AuthEndDate"
                                        placeholder="mm/dd/yyyy" (inputFieldChanged)="CareAUTHENDDatechange(i,$event)"
                                        (dateChanged)="onDateChangedCareAUTHEND(i,$event)"
                                        (focusout)="calculatetotalhour(its.startDate,its.endDate,its.totalUnits,i,its.billingvalue)">
                                    </my-date-picker>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-2 col-md-6 col-sm-12">
                            <label>Payer
                                <sup class="super-script">&nbsp;*</sup>
                            </label>
                            <ng-select [clearable]="true" [searchable]="true" [items]="payorList"
                            id="AuthPayer"
                                [(ngModel)]="its.payerId" bindLabel="Value" bindValue="Key"
                                (ngModelChange)="grouppayorService(its,true);">
                            </ng-select>
                        </div>
                        <div class="col-lg-2 col-md-6 col-sm-12 pr-0 pl-0">
                            <label>Service
                                <sup class="super-script">&nbsp;*</sup>
                            </label>
                            <ng-select [clearable]="true" [items]="its.grouppayorServiceArray" bindLabel="Value"
                            id="AuthService"
                                groupBy="type" bindValue="Key" [(ngModel)]="its.payerServiceMapId"
                                (ngModelChange)="serviceCodeUpdate(i,its.payerServiceMapId,'create',its.grouppayorServiceArray);getbillingValue(its);">
                                <ng-template ng-optgroup-tmp let-item="item">
                                    {{item.type}}
                                </ng-template>
                            </ng-select>
                            <label></label>
                        </div>
                        <div class="col-lg-2 col-md-6 col-sm-12">
                            <label>Description
                            </label>
                            <input type="text" class="form-control w-100" [(ngModel)]="its.serviceDescription"
                                disabled="true"  id="AuthDescription">

                                <label>{{its.authLimitType}}</label>
                        </div>
                    </div>
                         
                    <div class="row">

                        <div class="col-lg-5 col-md-6 col-sm-12 pr-0 pl-0">
                            <div class="row">
                                <div class="col-lg-4 col-md-6 col-sm-12">
                                    <label>Net Rate
                                    </label>
                                    <input type="text" class="form-control w-100" [(ngModel)]="its.netRate" id="AuthNetRate">
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12">
                                    <label>UC Rate
                                    </label>
                                    <input type="text" class="form-control w-100" [(ngModel)]="its.ucRate" id="AuthUCRate">
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12">
                                    <label>Authorization Number </label>
                                    <input type="text" class="form-control w-100" [(ngModel)]="its.serviceAgreementNo" id="AuthSeNo">
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-1">
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-12">
                                    <label>Total Units
                                        <sup class="super-script">&nbsp;*</sup></label>
                                    <input type="number" class="form-control w-100" [(ngModel)]="its.totalUnits" 
                                    id="AuthTtUts"
                                        (keypress)="allowonlynum($event)"
                                        (ngModelChange)="calculatetotalhour(its.startDate,its.endDate,its.totalUnits,i,its.billingvalue)">
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-12">
                                    <label>Insurance Number <sup class="super-script">&nbsp;*</sup></label>
                                    <input type="text" class="form-control w-100" [(ngModel)]="its.insuranceNo">
                                  <span style="color: red;" *ngIf="its.insuranceNo && its.insuranceNo.length < 2">
  Please enter at least 2 digits for insurance number
</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-1 col-md-6 col-sm-12">
                            <label>Hours Per Day</label>
                            <input type="text" class="form-control w-100" [(ngModel)]="its.unitperday"
                                [disabled]="true"    id="AuthHpD">
                        </div>
                        <div class="col-lg-2 col-md-6 col-sm-12">
                            <label>Temp Auth</label>
                            <br />
                            <input type="checkbox" [(ngModel)]="its.DisableAuthorization"  id="AuthTempAuth"/>
                            &nbsp;
                            <button class="btn btn-sm btn-primary ml-3" (click)="addSer(i,its)" *ngIf="its.isAdd"> <i
                                    class="fa fa-plus" aria-hidden="true"  id="AuthPlus"></i></button>
                                    <!-- *ngIf="!its.isAdd" -->
                                    &nbsp;    
                            <button class="btn btn-danger btn-sm ml-3" (click)="removeList(i)"  *ngIf="i!=0" >
                                <i class="fa fa-times" id="AuthTimes"></i></button>
                                &nbsp;
                            <button class="btn btn-danger btn-sm ml-1" (click)="cleardata(i)" id="AuthClear">Clear
                            </button>
                        </div>
                    </div>
                        


                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-sm btn-primary" [disabled]="loadingAuthadd" (click)="checkValidation(serviceinbox)" id="AuthSave"> Save &
                    Close</button>
                <button type="button" class="btn btn-sm btn-primary" data-bs-dismiss="modal"
                    (click)="back()" id="AuthCancel">Cancel</button>
            </div>
        </div>
    </div>
</div>


<span id="editmodelopen" data-bs-toggle="modal" data-bs-target="#clientauthorizationupdate"></span>
<div class="modal  fade" id="clientauthorizationupdate" tabindex="-1" aria-labelledby="exampleModalLabel"
aria-hidden="true" data-bs-backdrop="static">
<div class="modal-dialog modal-xl">
    <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title font-header" id="exampleModalLabel">
                Update Authorization </h5>
        </div>
        <div class="alert alert-warning alert-dismissible fade show" *ngIf="saveAuthErr!=''" role="alert">
            <p>{{saveAuthErr}}</p>
            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close" (click)="saveAuthErr=''">
                <span aria-hidden="true"> </span>
            </button>
        </div>
        <div class="modal-body">
            <div class="row">
                <div class="col-lg-6">
                    <div class="mt-3 row">
                        <div class="col-lg-5">
                            <label class="updatelabel">Start Date
                                <sup class="super-script">&nbsp;*</sup></label>
                        </div>
                        <div class="col-lg-7">
                            <my-date-picker [options]="myDatePickerOptions" [selDate]="updateAuthList.startDate"
                            id="updateStartDate"
                                placeholder="mm/dd/yyyy" (inputFieldChanged)="UpdateAUTHStartDatechange($event)"
                                (dateChanged)="onDateChangedCareUpdateAUTHStart($event)"
                                (focusout)="calculatetotalhour1(updateAuthList.startDate,updateAuthList.endDate,updateAuthList.totalUnits,updateAuthList.billingvalue)">
                            </my-date-picker>
                        </div>
                    </div>
                    <div class="mt-3 row">
                        <div class="col-lg-5">
                            <label class="updatelabel">End Date
                                <sup class="super-script">&nbsp;*</sup></label>
                        </div>
                        <div class="col-lg-7">
                            <my-date-picker [options]="myDatePickerOptions" [selDate]="updateAuthList.endDate"
                            id="updateEndDate"
                                placeholder="mm/dd/yyyy" (inputFieldChanged)="UpdateAUTHENDchange($event)"
                                (dateChanged)="onDateChangedUpdateAUTHENd($event)"
                                (focusout)="calculatetotalhour1(updateAuthList.startDate,updateAuthList.endDate,updateAuthList.totalUnits,updateAuthList.billingvalue)">
                            </my-date-picker>
                        </div>
                    </div>
                    <div class="mt-3 row">
                        <div class="col-lg-5">
                            <label class="updatelabel">Company&nbsp;</label>
                        </div>
                        <div class="col-lg-7">
                            <ng-select [clearable]="true" [searchable]="true" [items]="companyList"
                            id="updateCompany"
                                bindLabel="label" bindValue="value" [(ngModel)]="updateAuthList.companyId">
                            </ng-select>
                        </div>
                    </div>
                    <div class="mt-3 row">
                        <div class="col-lg-5">
                            <label class="updatelabel">Payer<sup class="super-script">&nbsp;*</sup>&nbsp;</label>
                        </div>
                        <div class="col-lg-7">
                            <ng-select [clearable]="true" [searchable]="true" [items]="payorList"
                            id="UpdatePayer"
                                [(ngModel)]="updateAuthList.payerId" bindLabel="Value" bindValue="Key"
                                (ngModelChange)="grouppayorService(updateAuthList,true);">
                            </ng-select>
                        </div>
                    </div>
                    <div class="mt-3 row">
                        <div class="col-lg-5">
                            <label class="updatelabel">Service Code
                                <sup class="super-script">&nbsp;*</sup></label>
                        </div>
                        <div class="col-lg-7">
                            <ng-select [clearable]="true" [searchable]="true" [items]="grouppayorServiceArray1" id="UpdateServiceCode"
                                bindLabel="Value" bindValue="Key" [(ngModel)]="updateAuthList.payerServiceMapId"
                                (ngModelChange)="serviceCodeUpdate(-1,updateAuthList.payerServiceMapId,'update',grouppayorServiceArray1);getbillingValue(updateAuthList)"
                                groupBy="type" >
                                <ng-template ng-optgroup-tmp let-item="item">
                                    {{item.type}}
                                </ng-template>
                            </ng-select>
                        </div>
                    </div>

                    <!-- <div class="mt-3 row">
                        <div class="col-lg-5">
                            <label class="updatelabel">Auth Limit
                                <sup class="super-script">&nbsp;*</sup></label>
                        </div>
                        <div class="col-lg-7">
                            <input type="text" class="form-control" [(ngModel)]="updateAuthList.authLimitType" disabled>
                        </div>
                    </div> -->

                    <div class="row" class="mt-3 row">
                        <div class="col-lg-5">
                            <label class="updatelabel">Ser
                                Description&nbsp;</label>
                        </div>
                        <div class="col-lg-7">
                            <input type="text" class="form-control" id="UpdateServiceDescription"[(ngModel)]="updateAuthList.serviceDescription">
                        </div>
                    </div>
                    <div class="row" class="mt-3 row">
                        <div class="col-lg-5">
                            <label class="updatelabel">Temp Auth
                                &nbsp;</label>
                        </div>
                        <div class="col-lg-7">
                            <input type="checkbox"  id="UpdateTempAuth" [(ngModel)]="updateAuthList.DisableAuthorization">
                        </div>
                    </div>
                    <div class="row" class="mt-3 row">
                        <div class="col-lg-5">
                            <label class="updatelabel">Exclude From Expired
                                &nbsp;</label>
                        </div>
                        <div class="col-lg-7">
                            <input type="checkbox" [(ngModel)]="updateAuthList.excludeAuth" id="UpdateEFE">
                        </div>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="mt-3 row">
                        <div class="col-lg-5">
                            <label class="updatelabel">Net Rate
                            </label>
                        </div>
                        <div class="col-lg-7">
                            <input type="text" class="form-control" [(ngModel)]="updateAuthList.netRate" id="UpdateNetRate">
                        </div>
                    </div>
                    <div class="mt-3 row">
                        <div class="col-lg-5">
                            <label class="updatelabel">Unit Rate
                            </label>
                        </div>
                        <div class="col-lg-7">
                            <input type="text" class="form-control" [(ngModel)]="updateAuthList.ucRate" id="UpdateUcRate">
                        </div>
                    </div>
                    <div class="mt-3 row">
                        <div class="col-lg-5">
                            <label class="updatelabel">Insurance Number
                                <sup class="super-script">&nbsp;*</sup></label>
                        </div>
                        <div class="col-lg-7">
                            <input type="text" class="form-control" id="UpdateInsurance"  name="insuranceNo"
                             [(ngModel)]="updateAuthList.insuranceNo" minlength="2" required #insuranceNo="ngModel">
                              <div *ngIf="insuranceNo.invalid" class="text-danger mt-1">
    <div *ngIf="insuranceNo.errors?.['minlength']">
      Please enter at least 2 digits for insurance number
    </div>
    </div>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-lg-5">
                            <label class="updatelabel">Authorization Number </label>
                        </div>
                        <div class="col-lg-7">
                            <input type="text" class="form-control" [(ngModel)]="updateAuthList.serviceAgreementNo" id="UpdateSeNo">
                        </div>
                    </div>
                    <div class="mt-3 row">
                        <div class="col-lg-5">
                            <label class="updatelabel">Total Units
                                <sup class="super-script">&nbsp;*</sup></label>
                        </div>
                        <div class="col-lg-7">
                            <input type="text" class="form-control" [(ngModel)]="updateAuthList.totalUnits"
                            id="UpdateTotalUnits"
                                (keypress)="allowonlynum($event)"
                                (ngModelChange)="calculatetotalhour1(updateAuthList.startDate,updateAuthList.endDate,updateAuthList.totalUnits,updateAuthList.billingvalue)">
                        </div>
                    </div>
                    <div class="mt-3 row">
                        <div class="col-lg-5">
                            <label class="updatelabel">Total Hours Per
                                Day&nbsp;</label>
                        </div>
                        <div class="col-lg-7">
                            <input type="text" [disabled]="true" class="form-control" id="UpdateTotalHoursPerDay"
                                [(ngModel)]="updateAuthList.totalUnitsperday">
                        </div>
                    </div>                    
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button class="btn btn-sm btn-primary " *ngIf="updateAuthList.id!=undefined"
                (click)="updateClientAuth(updateAuthList)" [disabled]="loadingAuthadd || updateAuthList.startDate==null || updateAuthList.startDate=='' || updateAuthList.startDate==undefined 
            || updateAuthList.endDate==null    || updateAuthList.endDate=='' || updateAuthList.endDate==undefined
            || updateAuthList.payerServiceMapId==null    || updateAuthList.payerServiceMapId==undefined
            || updateAuthList.insuranceNo==null    || updateAuthList.insuranceNo==undefined ||updateAuthList.insuranceNo.length < 2
            || (updateAuthList.totalUnits==null || updateAuthList.totalUnits=='' )    || updateAuthList.totalUnits==undefined " id="Update_Close">Update & Close
            </button>
            <button type="button" class="btn btn-sm btn-primary" data-bs-dismiss="modal"
                (click)="back()" id="UpdateCancel">Cancel</button>
        </div>
    </div>
</div>
</div>
<!------------------------------------delete Modal----------------------------------------->
<span id="deletemodal" data-bs-toggle="modal" data-bs-target="#deleteauth"></span>
<div class="modal fade" id="deleteauth" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
aria-hidden="true" data-bs-backdrop="static">
<div class="modal-dialog create-update-zip" role="document">
    <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title font-header" id="exampleModalLabel">Delete Record</h5>
        </div>
        <div class="modal-body">
            Do you want to delete this record ?
        </div>
        <div class="modal-footer">
            <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal"
                (click)="deleteAuth()">Yes</button>
            <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal" (click)="back()">No</button>
        </div>
    </div>
</div>
</div>


